import {FieldValidator} from './field.validator';
import {FieldMessage} from './field.message';
import {AmountValidator, IbanValidator, MatchValidator, TypeValidator} from './validators';
import {ValidateOnBlurDirective} from './validate.on.blur.directive';
import {
    TrimDirective,
    InputPatternDirective,
    RestrictForbiddenCharacterInputDirective,
    ToUppercaseDirective, ToUppercaseTdDirective,
    WhitespacesRemoveDirective, WhitespacesRemoveTdDirective,
    InputModifierService, InputPatternFormatter
} from '../input-modifiers';

export const VALIDATION_DIRECTIVES = [
    FieldValidator,
    FieldMessage,
    MatchValidator,
    TypeValidator,
    AmountValidator,
    IbanValidator,
    ValidateOnBlurDirective,
    RestrictForbiddenCharacterInputDirective,
    ToUppercaseDirective,
    ToUppercaseTdDirective,
    WhitespacesRemoveDirective,
    WhitespacesRemoveTdDirective,
    InputPatternDirective,
    TrimDirective,
    InputPatternFormatter
];

export const VALIDATION_PROVIDERS = [InputModifierService];

export * from './field.validator';
export * from './field.message';
export * from './validators';


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/validation/index.ts